module.exports = __webpack_public_path__ + "static/img/14-04.805f962.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/14-04.png
// module id = pAoy
// module chunks = 1